import { Component, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { TaskComponent } from '../task/task.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogService } from 'src/app/dialog/services/dialog.service';

@Component({
  selector: 'app-task-detail-dialog',
  templateUrl: './task-detail-dialog.component.html',
  styleUrls: ['./task-detail-dialog.component.css']
})
export class TaskDetailDialogComponent {
  requestid = 0;

  dialogBoxSubscription?: Subscription;
  constructor(public dialogRef: MatDialogRef<TaskComponent>,
    private readonly dialogService: DialogService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.requestid = data.id;
    }

  ngOnInit() {

  }

    closeDialog() {
      this.dialogRef.close();
    }
}
